export enum ShowValueAddedEnum {
  No = 0,
  Yes,
}
